import { useDispatch } from 'react-redux';
import { FieldValues, useFormContext } from 'react-hook-form';
import { useUpdateThirdPartyIntegration } from 'api/ThirdPartyIntegrationsAPI';
import { InputField, CheckboxField, BorderedRadioListField } from 'lib/iterable-hook-form';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { FormField } from 'ui/formField';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { FlexContainer } from './CreateSegmentIntegrationModal.styled';
import { fetchThirdPartyIntegrationsRequest } from '../actions';
import { useModalsContext, ThirdPartyIntegrationFormSchema } from '../contexts';
import { ENABLED, ID, ANALYTICS_REGION, API_TOKEN } from '../constants';
import { ThirdPartyIntegration, AnalyticsRegion } from '../types';
import { createRadioOptions } from '../utils';

export const EditSegmentIntegrationModal = () => {
  const { hideModal } = useModalsContext();
  const dispatch = useDispatch();

  const {
    handleSubmit,
    formState: { isValid, isDirty, errors, defaultValues },
  } = useFormContext<ThirdPartyIntegrationFormSchema>();

  const { [ID]: id } = defaultValues as ThirdPartyIntegration;

  const { mutate: editThirdPartyIntegration } = useUpdateThirdPartyIntegration({
    onSuccess: () => {
      hideModal();
      dispatch(fetchThirdPartyIntegrationsRequest());
    },
  });

  const onSubmit = (values: FieldValues) => {
    editThirdPartyIntegration(values);
  };

  return (
    <Modal
      id="edit-segment-integration-modal"
      isModalOpen
      onClose={hideModal}
      size={MODAL_SIZES.MEDIUM}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader>Edit Segment integration ID: {id}</ModalHeader>
      <ModalBody>
        <form>
          <FormField
            labelText="Write key"
            inputId="write-key-input"
            errorText={errors?.[API_TOKEN]?.message}
            hasError={!!errors?.[API_TOKEN]}
          >
            <InputField id="write-key-input" name={API_TOKEN} autoFocus />
          </FormField>
          <FormField labelText="Region">
            <FlexContainer>
              {createRadioOptions(Object.values(AnalyticsRegion))?.map((option) => (
                <BorderedRadioListField
                  key={option.id}
                  name={ANALYTICS_REGION}
                  options={[{ ...option, isDisabled: true }]}
                />
              ))}
            </FlexContainer>
          </FormField>

          <FormField labelText="Enabled" inputId="integration-enabled-checkbox">
            <CheckboxField name={ENABLED} id="integration-enabled-checkbox" />
          </FormField>
        </form>
      </ModalBody>
      <ModalFooter>
        <PrimaryButton
          isDisabled={!(isValid && isDirty)}
          onClick={handleSubmit(onSubmit)}
          size={BUTTON_SIZES.LARGE}
        >
          Save integration
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
